export default function ({ store, redirect }) {
  if (!process.server) {
    // If the user is not authenticated
    if (!store.state.authUser) {
      return redirect('/login/')
    }
  }
}
